import { FieldValues } from 'react-hook-form';
import { GetPatientCasesParams, PatientSort } from 'types';

export const parseFormDataToRequestParams = (data: FieldValues, search?: string, sort?: PatientSort) => {
  const { taskStatus, doctors, clinics, archived, treatmentPlans, isTaskBlocked } = data;
  const requestParams: GetPatientCasesParams = {};
  if (doctors) {
    requestParams['doctorIds'] = doctors;
  }
  if (clinics) {
    requestParams['clinicIds'] = clinics;
  }
  if (taskStatus) {
    requestParams['tasks'] = taskStatus;
  }
  if (treatmentPlans) {
    requestParams['treatmentPlanTypes'] = treatmentPlans;
  }
  if (archived) {
    requestParams['isArchived'] = true;
  } else {
    requestParams['isArchived'] = false;
  }
  if (search) {
    requestParams.search = search;
  }
  if (sort) {
    requestParams.sort = sort;
  }
  if (isTaskBlocked) {
    requestParams.isTaskBlocked = true;
  }
  return requestParams;
};
